import TimeWorker from './time.worker';

let worker = null;

export const getTimeWork = () => {
  if (worker) return worker;

  worker = new TimeWorker();

  return worker;
};

export const stopTimeWorker = () => {
  if (worker) {
    worker.postMessage('stopTimerInterval');

    worker = null;
  }
};
